<template>
  <section class="wallet new-user d-block col my-4">
    <div class="d-flex flex-column justify-content-end">
      <div class="top col-xxs-11 d-flex align-self-end justify-content-start">
        <h5 class="d-flex p-3 m-0 align-self-center">
          {{ $t('UserProfile.Wallet.NewUser.Title') }}
        </h5>
      </div>
      <div class="main d-flex flex-column p-4">
        <p v-html="$t('UserProfile.Wallet.NewUser.Description')" />
        <UserProfileChargeWallet />
      </div>
      <div class="d-flex band position-absolute justify-content-center mt-3 p-3 mx-5">
        <div class="rounded-circle push" />
      </div>
    </div>
  </section>
</template>

<script>
import UserProfileChargeWallet from '@/components/UserProfileChargeWallet.vue'
export default {
  name: 'UserProfileNewUserWallet',
  components: {
    UserProfileChargeWallet
  }
}
</script>
